/** Nomes legais do cliente (campo `name` / value do autocomplete) que habilitam o bloco Abbott. */
export const ABBOTT_CLIENT_NAMES = [
  "ABBOTT LABORATORIOS DO BRASIL LTDA",
  "ABBOTT DIAGNOSTICOS RAPIDOS S.A.",
  "ST JUDE MEDICAL BRASIL LTDA",
] as const;

export function normalizeClientNameForAbbott(name?: string | null): string {
  return String(name ?? "")
    .trim()
    .toUpperCase();
}

export function isAbbottClient(clientName?: string | null): boolean {
  const normalized = normalizeClientNameForAbbott(clientName);
  if (!normalized) return false;
  return (ABBOTT_CLIENT_NAMES as readonly string[]).includes(normalized);
}
